import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    years: [], // [{ year: 2025, months: [{ name: 'July', from: '...', to: '...' }] }]
    payrollLoaded: false,
  }),
  mutations: {
    SET_PAYROLL(state, years) {
      state.years = years
      state.payrollLoaded = true
    },
  },
  actions: {
    async fetchPayroll({ commit, state }) {
      if (!state.payrollLoaded) {
        const res = await axios.get('payroll')
        const { data } = decryptData(res.data.payload)

        const payrolls = data.payrolls || []
        const yearMap = {}

        payrolls.forEach(p => {
          const fromDate = new Date(p.from)
          const fromYear = fromDate.getFullYear()
          const fromMonth = fromDate.toLocaleString('en-US', { month: 'long' })

          if (!yearMap[fromYear]) yearMap[fromYear] = []

          // Only push the "from" month with full range
          yearMap[fromYear].push({
            name: fromMonth,
            from: p.from,
            to: p.to,
            id: p.id,
          })
        })

        // build final array
        const years = Object.keys(yearMap).map(year => ({
          year,
          months: yearMap[year],
        }))

        commit('SET_PAYROLL', years)
      }
    },
  },
  getters: {
    years: state => state.years,
    payrollLoaded: state => state.payrollLoaded,
  },
}
